import React from 'react';
import { Navbar } from '../components/Navbar';
import { TrustBar } from '../components/TrustBar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { OpenclawHero } from '../components/openclaw-sales/OpenclawHero';
import { OpenclawWorkflow } from '../components/openclaw-sales/OpenclawWorkflow';
import { OpenclawFeatures } from '../components/openclaw-sales/OpenclawFeatures';
import { OpenclawDemo } from '../components/openclaw-sales/OpenclawDemo';
import { OpenclawComparison } from '../components/openclaw-sales/OpenclawComparison';
import { OpenclawPricing } from '../components/openclaw-sales/OpenclawPricing';
import { OpenclawUseCases } from '../components/openclaw-sales/OpenclawUseCases';
import { OpenclawFAQ } from '../components/openclaw-sales/OpenclawFAQ';
import { OpenclawCta } from '../components/openclaw-sales/OpenclawCta';
import { DatabaseIcon, MailIcon, SearchIcon, UsersIcon, MapIcon, MegaphoneIcon } from 'lucide-react';
const relatedFeatures = [{
  title: 'Local business database',
  description: 'Access 200M+ local businesses with verified contacts.',
  href: '#/local-business-database',
  cta: 'Explore database',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Email sequencing',
  description: 'Automate your outreach with built-in B2B sequences.',
  href: '#/email-sequencing',
  cta: 'Explore sequencing',
  type: 'Tool',
  color: 'blue' as const,
  icon: MailIcon
}, {
  title: 'Local business enrichment',
  description: 'Enrich your existing lists with fresh local data.',
  href: '#/local-business-enrichment',
  cta: 'Explore enrichment',
  type: 'Tool',
  color: 'green' as const,
  icon: SearchIcon
}, {
  title: 'Owner finder',
  description: 'Find direct contact info for local business owners.',
  href: '#/owner-finder',
  cta: 'Explore owner finder',
  type: 'Tool',
  color: 'orange' as const,
  icon: UsersIcon
}, {
  title: 'Google Maps scraper',
  description: 'Extract and enrich business data from Google Maps at scale.',
  href: '#/google-maps-scraper',
  cta: 'Explore scraper',
  type: 'Tool',
  color: 'blue' as const,
  icon: MapIcon
}, {
  title: 'Local marketing',
  description: 'Build hyper-targeted audiences for local ad campaigns.',
  href: '#/local-marketing',
  cta: 'Explore marketing',
  type: 'Tool',
  color: 'green' as const,
  icon: MegaphoneIcon
}];
export function OpenclawForSales() {
  return <div className="min-w-full bg-slate-50/50 ecom-aeonik flex flex-col min-h-screen selection:bg-blue-100 selection:text-blue-900" style={{
    fontFamily: 'Aeonik, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  }} data-id="element-6937">
      <Navbar data-id="element-6938" />
      <main className="flex-grow pt-12 pb-24 space-y-12 md:space-y-24" data-id="element-6939">
        <OpenclawHero data-id="element-6940" />
        <TrustBar data-id="element-6941" />
        <OpenclawWorkflow data-id="element-6942" />
        <OpenclawFeatures data-id="element-6943" />
        <OpenclawDemo data-id="element-6944" />
        <OpenclawComparison data-id="element-6945" />
        <OpenclawPricing data-id="element-6946" />
        <OpenclawUseCases data-id="element-6947" />
        <OpenclawFAQ data-id="element-6948" />
        <RelatedFeatures features={relatedFeatures} data-id="element-6949" />
        <OpenclawCta data-id="element-6950" />
      </main>
      <Footer data-id="element-6951" />
    </div>;
}